import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { FormExam } from './form/FormExam';
import { EmployeeInfo } from './parts/EmployeeInfo';
import { CheckupInfo } from './parts/CheckupInfo';
import { FormMemo } from './form/FormMemo';
import { FormIneligible } from './form/FormIneligible';

import { examOrderState } from '../../store/examOrderState';
import { currentStatusState } from '../../store/currentStatusState';

export const DetailPage = memo((props) => {
  const { cm, user, staff_user, self_order, cource_pattern, clinics } = props;
  const [examOrderData, setExamOrderData] = useRecoilState(examOrderState);
  const [currentStatus, setCurrentStatus] = useRecoilState(currentStatusState);
  const initialExamOrderData = {
    examclinic: null,
    examclinic_id: '',
    examdt: null,
    examdtdate: null,
    examdtime: '',
    examnote: null,
    id: null,
    status: '',
    code: '',
  }

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const editAttachClass = () => {
    // cource_code[1..79]でstatusが確定または完了の場合
    if (
      (1 <= parseInt(self_order?.cource_code, 10) && parseInt(self_order?.cource_code, 10) < 79) &&
      (self_order?.status == "order_commited" || self_order?.status == "order_finished")
    ) {
      // examclinic_idが設定されていない場合
      if (!self_order?.examclinic_id) {
        return "btn btn-warning text-white w-100 disabled";
      } else {
        return "btn btn-warning text-white w-100";
      }
    } else {
      // statusが対象外の場合
      if (cource_pattern == "ineligibles") {
        return "btn btn-warning text-white w-100 disabled";
      } else {
        return "btn btn-warning text-white w-100";
      }
    }
  }

  const onClickDeleteCheckupSubmit = () => {
    const sure = window.confirm('Are you sure to delete ?');
    if (sure) {
      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.delete(`/agent/employees/${user.id}/checkup_operation/${examOrderData.id}`, {
        params: {
          employee_id: user.id,
          staff_user_id: staff_user,
        }
      })
      .then(resp => {
        console.log(resp);
        setExamOrderData(initialExamOrderData);
        setCurrentStatus("");
        notify("success", "Proxy Checkup successfully deleted!");
      })
      .catch(e => {
        console.log(e.response);
        notify("error", "Proxy Checkup delete Error!");
      })
    }
  }

  return (
    <>
      <ToastContainer />
      <div className="row">
        <div className="col-6">
          <div className="card mb-3">
            { examOrderData.id ?
              <Fragment>
                <div className="card-header">申込の操作</div>
                <FormExam
                  cm={cm}
                  user={user}
                  staff_user={staff_user}
                  self_order={self_order}
                  cource_pattern={cource_pattern}
                  clinics={clinics}
                />
              </Fragment>
            :
              <Fragment>
                <div className="card-header">申込の操作</div>
                <div className="card-body">
                  <a className='btn btn-outline-success w-100' href={`/agent/proxy_checkup/new?mtemployee_id=${user.id}`}>
                    <i className="fas fa-pencil-alt" /> 新規申込
                  </a>
                </div>
                <div className="card-header" style={{borderTop: "1px solid rgba(0, 0, 0, 0.125)"}}>（対象外）申込の操作</div>
                <div className="card-body">
                  <FormIneligible
                    user={user}
                    staff_user={staff_user}
                  />
                  </div>
              </Fragment>
            }
          </div>
          { examOrderData.id &&
            <div className="row justify-content-between">
              <div className="col-5">
                <a className={editAttachClass()} href={`/agent/proxy_checkup/edit?mtemployee_id=${user.id}`}>
                <i className="fa fa-share-square" /> 予約を変更する
                </a>
              </div>
              <div className="col-5">
                <button onClick={onClickDeleteCheckupSubmit} className='btn btn-danger w-100' title="Delete">
                  <i className="far fa-trash-alt" /> 予約を取消する
                </button>
              </div>
            </div>
          }
        </div>
        <div className="col-6">
          <div className="accordion mb-3" id="accordionPanelsStayOpenExample">
            <EmployeeInfo user={user} />
            <CheckupInfo />
            <FormMemo user={user} />
          </div>
        </div>
      </div>
    </>
  );
});